import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";

import {
  DEFAULT_PROFILE_FILTER,
  type ProfileFilterCriteria
} from "../../models/profile-filter";

@Component({
  selector: "app-profile-filter-dialog",
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
  ],
  templateUrl: "./profile-filter-dialog.component.html",
  styleUrl: "./profile-filter-dialog.component.scss"
})
export class ProfileFilterDialogComponent {
  draft: ProfileFilterCriteria;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { criteria: ProfileFilterCriteria },
    private readonly ref: MatDialogRef<ProfileFilterDialogComponent, ProfileFilterCriteria | undefined>
  ) {
    this.draft = { ...data.criteria };
    // Age range is intentionally fixed.
    this.draft.ageMin = 32;
    this.draft.ageMax = 32;
  }

  cancel(): void {
    this.ref.close(undefined);
  }

  apply(): void {
    // Age range is intentionally fixed.
    this.draft.ageMin = 32;
    this.draft.ageMax = 32;
    this.ref.close({ ...this.draft });
  }

  clearAll(): void {
    this.draft = { ...DEFAULT_PROFILE_FILTER };
    // Age range is intentionally fixed.
    this.draft.ageMin = 32;
    this.draft.ageMax = 32;
  }
}
